import { Inject, Injectable } from '@angular/core';
import { ICancelablePromiseService } from '../../src/typings/services';
import { $q } from '../ajs-upgraded-providers';

/**
 * This service is used to create & maintain promises that can be passed into a request's 'timeout' property
 * Maintain a dictionary outside of the service that is keyed by an ID that can be used to identify a request --
 * if a repeat request is made, we'll cancel the first promise & go ahead with the new one
 * This is base level functionality & may need to be expanded upon to support more than the most basic use case
 * (repeat requests for getSensorData, see SensorService.ts / getSensor())
 */
@Injectable({
    providedIn: 'root'
})
export class CancelablePromiseService implements ICancelablePromiseService {
    public static $name = 'clCancelablePromiseService';
    public static $inject = ['$q'];

    constructor(
        @Inject($q) public $q: angular.IQService
    ) {
    }

    public create(dictionary: { [key: string]: angular.IDeferred<any> }, key: string | number) {
        /** If it already existed and we're trying to create it again, we should go ahead and cancel & remove it */
        this.cancel(dictionary, key);

        let canceller = this.$q.defer();
        dictionary[key] = canceller;

        return canceller;
    }

    public cancel(dictionary: { [key: string]: angular.IDeferred<any> }, key: string | number) {
        if (dictionary[key]) {
            dictionary[key].resolve();
            delete dictionary[key];
        }
    }

    public cancelAll(dictionary: { [key: string]: angular.IDeferred<any> }) {
        for (let key in dictionary) {
            this.cancel(dictionary, key);
        }
    }
}
